<template>
  <div class="home">
    <top-details :total="total" :displayRange="displayRange" :loading="loading" @new-range="rangeChanged" />
    <v-skeleton-loader
      class="mx-auto"
      type="list-item-two-line@10"
      style="width: 100%; display: block;"
      tile
      v-if="loading"
    ></v-skeleton-loader>
    <div class="spend-list" v-else>
      <spend-item v-for="(item, index) in sortedItems" :key="index" :item="item" />
    </div>
    <v-list-item two-line v-if="sortedItems.length === 0">
      <v-list-item-content>
        <v-list-item-title>
          <strong>Ingen transaktioner:</strong>
        </v-list-item-title>
        <v-list-item-subtitle>
          Skift periode for at vise transaktioner
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-btn color="primary" dark fixed bottom right fab @click.prevent="addNew">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </div>
</template>

<script>
import TopDetails from "@/components/TopDetails";
import SpendItem from "@/components/SpendItem";
import axios from "axios";
import _ from "lodash";
import moment from 'moment';
import Eventbus from '@/Eventbus';

export default {
  components: {
    TopDetails,
    SpendItem
  },
  data() {
    return {
      loading: true,
      items: [],
      total: 0,
      dateRange: {
        start: moment().startOf('isoWeek').format('YYYY-MM-DD'),
        end: moment().endOf('isoWeek').format('YYYY-MM-DD')
      }
    };
  },
  computed: {
    displayRange() {
      return moment(this.dateRange.start).format('D. MMM YYYY') + ' - ' + moment(this.dateRange.end).format('D. MMM YYYY')
    },
    sortedItems() {
      const sorted = _.cloneDeep(this.items).sort((a, b) => {
        let dateA = new Date(a.date);
        let dateB = new Date(b.date);
        return dateB - dateA;
      });
      return sorted;
    }
  },
  mounted() {
    Eventbus.$on('update-data', () => {
      this.loadItems();
    });
  },
  created() {
    if (localStorage.getItem('range') !== null) {
      this.dateRange = JSON.parse(localStorage.getItem('range'));
      this.rangeChanged();
    } else {
      this.loadItems();
    }
  },
  methods: {
    rangeChanged() {
      this.dateRange = JSON.parse(localStorage.getItem('range'));
      this.loadItems();
    },
    loadItems() {
      this.loading = true;
      const startDate = moment(this.dateRange.start).format('YYYY-MM-DD');
      const endDate = moment(this.dateRange.end).format('YYYY-MM-DD');
      axios
        .post(
          "https://spend.hjertezonen.dk/wp-json/projects-api/v1/transactionrange",
          // "https://spend-api.lndo.site/wp-json/projects-api/v1/transactionrange",
          { email: localStorage.getItem('email'), startDate, endDate }
        )
        .then(result => {
          this.items = result.data.items;
          this.total = result.data.sum;
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
        });
    },
    addNew() {
      this.$router.push({ name: "add-new" });
    }
  }
};
</script>

<style lang="scss">
.home {
  padding-top: 173px;
}

.mx-auto {
  background-color: #fafafa;
}

.action-block-top {
  background-color: #ebebeb;
}
</style>
